import React from 'react';

import CasinoCRMApi from '../../../../../casino/Api/CRM/CasinoCRMApi';
import CasinoTransaction from '../../../../../casino/Api/Models/CasinoTransaction';
import useAutoPaginator from '../../../../hooks/useAutoPaginator';
import TransactionsTable from '../../../pages/Transactions/TransactionsTable';

interface Props {
    userId: number;
}

function CasinoTransactionsTable({ userId }: Props) {
    const { items, isLoading, auto } = useAutoPaginator<CasinoTransaction>((page, params) => {
        return CasinoCRMApi.transactions.getPaginatedByUserId(page, userId, { params });
    });

    return (
        <TransactionsTable
            transactions={items}
            isLoading={isLoading}
            sortProps={auto.sort}
            autoSearch={auto.search}
            autoFilter={auto.filter}
            autoPaginator={auto.paginator}
            hideUserDetails
        />
    );
}

export default CasinoTransactionsTable;
